
export default function loader(state = {}, action)
{
    switch (action.type){
        case 'IS_LOADING':
            return Object.assign({}, state, {
                loading: action.value
              })
        case 'IS_LOADING_MESSAGEQUEUE':
            return Object.assign({}, state, {
                loadingMessagequeue: action.value
              })
        case 'IS_LOADING_EXPORT':
            return Object.assign({}, state, {
                loadingExport: action.value
              })

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/loader.js